import { queryBot, queryBot2 } from 'boot/axios';
import unescapeSql from 'src/mixins/utils';
import ShortUniqueId from 'short-unique-id';

const moment = require('moment');

export const LOG_USERS_EVENTS = {
    Created: 'created', // Создан
    Updated: 'updated', // Обновлён
    Application: 'application', // Заявка
    Approved: 'approved', // одобрен
    Canceled: 'canceled', // отменен
    Enrolled: 'enrolled', // зачислен
    Dismissed: 'dismissed', // отчислен
    Diploma: 'diploma', // диплом
    FlowChanged: 'flow-changed', // изменен поток
    CourseChanged: 'course-changed', // изменен курс (смена курса)
    LoggedIn: 'logged-in', // вход под этим клиентом
    EmailSent: 'email-sent', // отправлен имейл
    SmsSent: 'sms-sent', // отправлено смс
    Activated: 'activated', // активирован
    Deactivated: 'deactivated', // деактивирован
    Removed: 'removed', // удален
    ErrorUid: 'error-uid', // ошибка Uid
    ErrorCourse: 'error-course', // ошибка курса
    ErrorGu: 'error-gu', // ошибка госуслуг
    AttachedToSchool: 'attach-school', // прикреплен к школе
    AttachedToPartner: 'attach-partner', // прикреплен к партнеру
    SchoolChanged: 'school-changed', // был прикреплен к другой школе, изменен
    RefCommentChanged: 'ref-com-changed', // изменился комментарий справки
    EntryPassed: 'entry-passed', // пройдена входная диагностика
    EntryAdded: 'entry-added', // добавлена диагностика вручную
    EntryAutoAccept: 'entry-auto', // Диагностика принята автоматически
    EntryAccept: 'entry-accept', // Диагностика принята оператором (Вася Пупкин)
    EntryDecline: 'entry-decline', // Диагностика отклонена оператором (Вася Пупкин)
    Payment: 'entry-decline', // Оплата
    StatusUpdated: 'status-updated', // Изменен статус
    PortfolioApproved: 'portfolio-approved', // Портфолио принято
    UserCatChanged: 'cat-changed', // Изменилась категория
    HashtagsChanged: 'tags-changed', // Изменились хештеги
    NameChanged: 'name-changed', // Изменилось ФИО обучаемого
    PreregPreset: 'prereg-reset', // сняли/установили флаг "Предрег"
    FlagChanged: 'flag-changed', // изменился какой-то флаг клиента
    Rich: 'rich', // обогащение данных
    UserOffer: 'user-offer', // клиент принял оферту
    AdminOffer: 'admin-offer', // админ изменил флаг оферты клиента
    PromocodeChanged: 'promo-changed', // изменился промокод
    SponsorChanged: 'sponsor-changed', // изменился спонсор
    SpoSchoolChanged: 'spo-sch-changed', // изменился спо/школа хештег
    Documents: 'documents', // статус документов клиента
    EmailChanged: 'email-changed', // изменен имейл клиента
};
export const LOG_MESSAGES_STATUS = {
    Sent: 0, // Отправлено
    Error: 1, // Ошибка
};

export const ACTIVITY_HISTORY_TYPES = {
    Module: 1, // Раздел
    Task: 2, // Тема
    Slide: 3, // Страница (слайд)
};

export const ACTIVITY_HISTORY_ACTIONS = {
    viewed: 'viewed', // Просмотр
    launched: 'launched', // Начат
    completed: 'completed', // Сдан
    passed: 'passed', // Зачтено
    failed: 'failed', // Не зачтено
    answered: 'answered', // Ответил
};

// eslint-disable-next-line import/prefer-default-export
export class Logs {
    constructor (app) {
        this.app = app;
        if (app) {
            this.context = this.app.config.globalProperties;
            this.$q = this.context.$q;
        }
    }

    // eslint-disable-next-line class-methods-use-this
    writeUsersLog (userId, event, comment, extra = '') {
        const author = localStorage.getItem('operatorName') || '';
        const data = {
            userId,
            event,
            comment,
            author,
            extra,
        };
        return queryBot2('insert-into-users-log', data);
    }

    // eslint-disable-next-line class-methods-use-this
    writeEventsLog (event, comment, isError = '0') {
        const author = localStorage.getItem('operatorName') || '';
        const sql = 'insert into events_log (event, author, comment, is_error) values '
            + ` ('${unescapeSql(event)}', '${unescapeSql(author)}', '${unescapeSql(comment)}', '${isError}') `;
        return queryBot(sql);
    }

    // eslint-disable-next-line class-methods-use-this
    writeMessagesLog (type, uid, name, contact, subject, text, status, error = '', messageId = undefined) {
        const author = localStorage.getItem('operatorName') || '';
        if (!messageId) {
            messageId = new ShortUniqueId({ length: 8 })();
        }
        const sql = 'insert into messages_log (type, uid, name, contact, subject, text, status, error, sent_at, message_id, author) values ( '
            + ` '${type}', `
            + ` '${uid}', `
            + ` '${unescapeSql(name)}', `
            + ` '${unescapeSql(contact)}', `
            + ` '${unescapeSql(subject)}', `
            + ` '${unescapeSql(text)}', `
            + ` '${unescapeSql(status)}', `
            + ` '${unescapeSql(error)}', `
            + ' now(), '
            + ` '${messageId}', `
            + ` '${author}' `
            + ')';
        return queryBot(sql);
    }

    // eslint-disable-next-line class-methods-use-this
    writeMessagesLog2 (type, userId, name, contact, subject, text, status, error = '', messageId = undefined) {
        const author = localStorage.getItem('operatorName') || '';
        if (!messageId) {
            messageId = new ShortUniqueId({ length: 8 })();
        }
        const sql = 'insert into messages_log (type, userId, name, contact, subject, text, status, error, sent_at, message_id, author) values ( '
            + ` '${type}', `
            + ` '${userId}', `
            + ` '${unescapeSql(name)}', `
            + ` '${unescapeSql(contact)}', `
            + ` '${unescapeSql(subject)}', `
            + ` '${unescapeSql(text)}', `
            + ` '${unescapeSql(status)}', `
            + ` '${unescapeSql(error)}', `
            + ' now(), '
            + ` '${messageId}', `
            + ` '${author}' `
            + ')';
        return queryBot(sql);
    }

    // eslint-disable-next-line class-methods-use-this
    writeActivityHistory (userId, pageType, pageId, action, activityType, courseId) {
        queryBot2('get-last-activity-log-datetime2', {
            userId,
            pageType,
            pageId,
            action,
        }).then((r) => {
            const [row] = r.data;
            if (row) {
                const createdAt = moment(row.created_at);
                const m = moment().diff(createdAt, 'minute');
                if (m < 5) {
                    return;
                }
            }
            queryBot2('add-to-user-activity2', {
                userId,
                pageType,
                pageId,
                action,
                activityType,
                courseId,
            });
        });
    }
}
